module.exports = __webpack_public_path__ + "img/prize2.3cacd810.png";